var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "box view-nav-bar" }, [
      _c(
        "div",
        { staticClass: "d-flex align-items-center w-100" },
        [
          _c(
            "router-link",
            {
              staticClass: "btn btn-sm btn-outline-secondary mr-3",
              attrs: { to: "/admissions/sources" },
            },
            [
              _c("icon", { attrs: { name: "chevron-left" } }),
              _vm._v(" Source files\n            "),
            ],
            1
          ),
          _vm._v(" "),
          _c("span", { staticClass: "text-muted mr-3" }, [
            _c("code", [_vm._v(_vm._s(_vm.file))]),
            _vm._v(" "),
            _vm.day
              ? _c("span", [
                  _vm._v("— play date "),
                  _c("strong", [_vm._v(_vm._s(_vm.day))]),
                  _vm._v(", " + _vm._s(_vm.revisions.length) + " revisions"),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.revisions.length
            ? [
                _c("label", { staticClass: "mb-0 mr-1 text-muted" }, [
                  _vm._v("From"),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.from,
                        expression: "from",
                      },
                    ],
                    staticClass: "form-control form-control-sm w-auto mr-3",
                    on: {
                      change: [
                        function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.from = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        _vm.reload,
                      ],
                    },
                  },
                  [
                    _c("option", { domProps: { value: null } }, [
                      _vm._v("(nothing)"),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.revisions, function (rev) {
                      return _c(
                        "option",
                        {
                          key: "from-" + rev.hash,
                          domProps: { value: rev.hash },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.revisionLabel(rev)) +
                              "\n                    "
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("label", { staticClass: "mb-0 mr-1 text-muted" }, [
                  _vm._v("To"),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.to,
                        expression: "to",
                      },
                    ],
                    staticClass: "form-control form-control-sm w-auto",
                    on: {
                      change: [
                        function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.to = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        _vm.reload,
                      ],
                    },
                  },
                  _vm._l(_vm.revisions, function (rev) {
                    return _c(
                      "option",
                      { key: "to-" + rev.hash, domProps: { value: rev.hash } },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.revisionLabel(rev)) +
                            "\n                    "
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _vm.loading
      ? _c("div", { staticClass: "box" }, [
          _c(
            "div",
            { staticClass: "box-content text-center text-muted py-4" },
            [_vm._v("Loading…")]
          ),
        ])
      : !_vm.revisions.length
      ? _c("div", { staticClass: "box" }, [
          _c(
            "div",
            { staticClass: "box-content text-center text-muted py-4" },
            [_vm._v("No git history found for this file.")]
          ),
        ])
      : _c("div", { staticClass: "box" }, [
          _c("div", { staticClass: "box-content" }, [
            _c("p", { staticClass: "mb-2" }, [
              _c("span", { staticClass: "badge badge-success mr-2" }, [
                _vm._v(_vm._s(_vm.summary.added) + " added"),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "badge badge-danger mr-2" }, [
                _vm._v(_vm._s(_vm.summary.removed) + " removed"),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "badge badge-warning mr-2" }, [
                _vm._v(_vm._s(_vm.summary.changed) + " changed"),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "text-muted" }, [
                _vm._v(
                  "\n                    Admissions in the affected rows:\n                    " +
                    _vm._s(_vm.formatInt(_vm.summary.admissions_before)) +
                    " → " +
                    _vm._s(_vm.formatInt(_vm.summary.admissions_after)) +
                    "\n                    ("
                ),
                _c(
                  "strong",
                  {
                    class: _vm.deltaClass(
                      _vm.summary.admissions_after -
                        _vm.summary.admissions_before
                    ),
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.formatDelta(
                          _vm.summary.admissions_after -
                            _vm.summary.admissions_before
                        )
                      )
                    ),
                  ]
                ),
                _vm._v(")\n                "),
              ]),
            ]),
            _vm._v(" "),
            !_vm.rows.length
              ? _c("div", { staticClass: "text-center text-muted py-4" }, [
                  _vm._v(
                    "\n                No row-level differences between these two revisions.\n            "
                  ),
                ])
              : _c("table", { staticClass: "shx-table w-100 mt-2" }, [
                  _c("thead", [
                    _c(
                      "tr",
                      [
                        _c("th", { staticClass: "shx-th-80" }),
                        _vm._v(" "),
                        _vm._l(_vm.columns, function (col, i) {
                          return _c(
                            "th",
                            {
                              key: col,
                              class: {
                                "text-right": i === _vm.admissionsIndex,
                              },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(col) +
                                  "\n                        "
                              ),
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c("th", { staticClass: "text-right shx-th-80" }, [
                          _vm._v("Δ"),
                        ]),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.rows, function (row, r) {
                      return _c(
                        "tr",
                        { key: r, class: _vm.rowClass(row) },
                        [
                          _c("td", [
                            _c(
                              "span",
                              {
                                staticClass: "badge",
                                class: _vm.badgeClass(row),
                              },
                              [_vm._v(_vm._s(row.type))]
                            ),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.columns, function (col, i) {
                            return _c(
                              "td",
                              {
                                key: col,
                                class: {
                                  "text-right": i === _vm.admissionsIndex,
                                },
                              },
                              [
                                i === _vm.admissionsIndex
                                  ? [
                                      row.type === "changed"
                                        ? _c("span", [
                                            _c(
                                              "s",
                                              { staticClass: "text-muted" },
                                              [_vm._v(_vm._s(row.before))]
                                            ),
                                            _vm._v(" → "),
                                            _c("strong", [
                                              _vm._v(_vm._s(row.after)),
                                            ]),
                                          ])
                                        : _c("span", [
                                            _vm._v(_vm._s(row.fields[i])),
                                          ]),
                                    ]
                                  : [_vm._v(_vm._s(row.fields[i]))],
                              ],
                              2
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "text-right",
                              class: _vm.deltaClass(row.after - row.before),
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.formatDelta(row.after - row.before)
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ],
                        2
                      )
                    }),
                    0
                  ),
                ]),
            _vm._v(" "),
            _vm._m(0),
          ]),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "text-muted small mt-2 mb-0" }, [
      _vm._v("\n                Rows are paired on every column except "),
      _c("code", [_vm._v("ADMISSIONS")]),
      _vm._v(
        ": a row that only changed its\n                admissions shows as "
      ),
      _c("em", [_vm._v("changed")]),
      _vm._v(" (old → new), otherwise it is "),
      _c("em", [_vm._v("added")]),
      _vm._v(" or\n                "),
      _c("em", [_vm._v("removed")]),
      _vm._v(
        ". Rows that merely moved within the file are not shown.\n                "
      ),
      _c("em", [_vm._v("(nothing)")]),
      _vm._v(" as From compares against an empty file.\n            "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }